import { inject } from "@angular/core";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { ILH_APPLICATIONS } from "@app/portals/ilh-modules/ilh-shared/constants/applications.constants";
import { ILH_PORTALS } from "@app/portals/ilh-modules/ilh-shared/constants/portal-constants";

export const IlhGuard = () => {
  const authService = inject(AuthenticationService);

  // Check for valid application and portal
  const application = authService.applicationId === ILH_APPLICATIONS.INDIVIDUAL;
  const portal = [ILH_PORTALS.AGENT, ILH_PORTALS.MEMBER, ILH_PORTALS.BENEFICIARY, ILH_PORTALS.GROUP].includes(
    authService.moduleId
  );

  if (!application || !portal) {
    return false;
  }

  return true;
};
